













import { computed, defineComponent, ref } from '@nuxtjs/composition-api';
import { SfButton } from '@storefront-ui/vue';

export default defineComponent({
  name: 'ProductHTMLContent',
  components: { SfButton },
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    content: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const isExpanded = ref(false);

    // 计算属性用于生成截取后的内容
    const truncatedContent = computed(() => {
      if (props.content.length > 800) {
        isExpanded.value = true;
        return `${props.content}`;
      }
      return props.content;
    });

    // 切换显示状态
    const toggleContent = () => {
      isExpanded.value = !isExpanded.value;
    };

    return {
      isExpanded,
      truncatedContent,
      toggleContent,
    };
  },
});
